export default "__VITE_ASSET__7jV8uRuI__"